// removed by extract-text-webpack-plugin
module.exports = {"main-area":"main-area__jXRPp","gallery":"gallery__GvmLP","half-width":"half-width__2EPpC","full-width":"full-width__lBj7N"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleDetail/styles/MainArea.scss
// module id = wHCS
// module chunks = 1